export const transform = (data: any[]) => {
  if (!data) return [];

  return data.map(campaign => ({
    id: campaign.id,
    label: campaign.title,
    isTerraBrasil: campaign.GrupoID === 6,
  }));
};
